<template>
    <div>
        <slot v-if="isActive" />
    </div>
</template>

<script>
    export default {
        computed: {
            isActive () {
                return this.activeTab?.id === this.id
            }
        },
        props: {
            title: {
                type: String,
                required: true
            },
            activeTab: {
                type: Object
            },
            id: {
                type: String,
                default: () => `tab-${Math.random()}`
            }
        },
        mounted () {
            this.$emit('tabMounted', this)
        }
    }
</script>
